import { FeatureFlagDefaultPage } from '../FeatureFlag/FeatureFlagManagerWithDefaultPage'

export default function ToNotFound({
  children,
  shouldFindRoute
}: {
  children: React.ReactNode
  shouldFindRoute: boolean
}) {
  if (shouldFindRoute) return children
  return <FeatureFlagDefaultPage />
}
